import type { AlertSummary } from "../api/types";

// Display order (highest severity first) and short labels. Unknown severities
// fall back to rank 0 and their raw name, so adding one to IRM_SEVERITIES just works.
const RANK: Record<string, number> = { critical: 3, error: 2, warning: 1 };
const ABBREV: Record<string, string> = { critical: "crit", error: "err", warning: "warn" };

export default function AlertBadge({ summary }: { summary: AlertSummary | null | undefined }) {
    if (!summary || summary.total === 0) return null;
    const parts = Object.entries(summary.counts)
        .filter(([, n]) => n > 0)
        .sort(([a], [b]) => (RANK[b] ?? 0) - (RANK[a] ?? 0) || a.localeCompare(b))
        .map(([sev, n]) => `${n} ${ABBREV[sev] ?? sev}`);
    // Red only when something critical is open; everything else (error/warning) is yellow.
    const tone = (summary.counts.critical ?? 0) > 0 ? "red" : "yellow";
    const chip = <span className={`alert-badge ${tone}`}>{parts.join(" · ")}</span>;
    if (!summary.irmUrl) return chip;
    return (
        <a href={summary.irmUrl} target="_blank" rel="noopener noreferrer" title="Open in Grafana IRM">
            {chip}
        </a>
    );
}
